import React from 'react';
import logError from 'App/babel/helpers/logError';
import T from 'Components/Helpers/translate';
import SupersearchHistory from 'Components/Supersearch/SupersearchHistory';
import SupersearchActions from './SupersearchActions';
import SupersearchFooter from './SupersearchFooter';
import SupersearchResultHeader from 'Components/Supersearch/SupersearchResultHeader';
import {
	SupersearchResultRowClient,
	SupersearchResultRowContact,
	SupersearchResultRowActivity,
	SupersearchResultRowAppointment,
	SupersearchResultRowOrder,
	SupersearchResultRowOpportunity
} from 'Components/Supersearch/SupersearchResultRow';
import { Icon, Tooltip } from '@upsales/components';
import SupersearchNoResults from './SupersearchNoResults';
import SupersearchAIActions from './SupersearchAIActions';
import history from 'App/pages/routes/history';
import { openEditAppointment } from 'Components/Modals/Appointment/EditAppointment';
import { openNewMailWithContact } from 'App/helpers/mailHelpers';
import { openEditOrder } from 'App/components/EditOrder';
import InactiveLabel from 'Components/Misc/InactiveLabel';
import ReactCreateClass from 'create-react-class';
import { getAllowedCountries, StatusCategory } from 'App/services/prospectingService';
import Prospecting from 'App/babel/resources/Prospecting';
import RequestBuilder, { comparisonTypes } from 'App/babel/resources/RequestBuilder';

const SUPERSEARCH_PROSPECTING_LIMIT = 5;

const onProspectingSearch = function (searchStr) {
	const trimmed = searchStr ? searchStr.trim() : '';
	if (trimmed.length < 2) {
		return Promise.resolve({ data: [], metadata: { total: 0 } });
	}
	const countries = getAllowedCountries();
	if (!countries.length) {
		return Promise.resolve({ data: [], metadata: { total: 0 } });
	}
	const primaryCountry = countries[0];

	const rb = new RequestBuilder();
	rb.addFilter({ field: 'headquarters' }, comparisonTypes.Equals, true);
	rb.addFilter({ field: 'statusCategory' }, comparisonTypes.Equals, [
		StatusCategory.ActiveWithWarning,
		StatusCategory.Active
	]);
	rb.addFilter({ field: 'name' }, comparisonTypes.Search, trimmed);
	// revenueSort is unavailable for NO/FI — fall back to plain revenue there
	if (primaryCountry === 'NO' || primaryCountry === 'FI') {
		rb.addSort('revenue', false);
	} else {
		rb.addSort('revenueSort', false);
	}
	rb.fields = ['prospectingId', 'name', 'orgNumber', 'visitingTown', 'postTown', 'registeredTown'];
	rb.limit = SUPERSEARCH_PROSPECTING_LIMIT;
	rb.extraParams.push({ key: 'country', value: primaryCountry });

	const filters = rb.build();
	filters.countries = countries;

	return Prospecting.find(filters);
};

const onSearch = function (searchStr, ts, options) {
	var searchValue = searchStr.split(' ');
	searchValue.length = 15;
	searchValue = searchValue.join(' ');
	searchValue = searchValue.trim();
	const customerId = Tools.AppService.getCustomerId();

	return Tools.SearchService.search(searchValue, customerId, null, ts, options).then(function (results) {
		var res = { numResults: 0, data: {}, ts: results.ts };
		angular.forEach(results, function (entity) {
			var data = entity.data;
			var type = entity.type;
			if (/^(client|activity|opportunity|appointment|order|contact|subAccount)$/.test(type)) {
				res.data[type] = entity;
			}

			if (data) {
				res.numResults += data.length;
			}
		});

		return res;
	});
};

const rowComponents = {
	client: { component: SupersearchResultRowClient, fieldKey: 'account' },
	subAccount: { component: SupersearchResultRowClient, fieldKey: 'account' },
	contact: { component: SupersearchResultRowContact, fieldKey: 'contact' },
	activity: { component: SupersearchResultRowActivity, fieldKey: 'activity' },
	appointment: { component: SupersearchResultRowAppointment, fieldKey: 'appointment' },
	order: { component: SupersearchResultRowOrder, fieldKey: 'order' },
	opportunity: { component: SupersearchResultRowOpportunity, fieldKey: 'opportunity' }
};

const NavbarCfResults = props => {
	var matches = [];

	if (props.customFields) {
		props.customFields.each(function (field, i) {
			var valObj = props.values.find({ fieldId: field.id });
			if (valObj && (props.isMatch(valObj.value) || props.alwaysShow)) {
				matches.push(
					<span className="field" key={'result-custom-' + i}>
						<span>{field.name}</span>
						{': '}
						<span>{props.hl(valObj.value)}</span>
					</span>
				);
			}
		});
	}

	return matches.length ? (
		<div className="custom-fields">
			{matches}
			<div className="clearfix" />
		</div>
	) : null;
};

const NavbarUserComponent = ReactCreateClass({
	setWidth: function () {
		if (!this._hovTrig) {
			return;
		}
		var hovTriggerWidth = this._hovTrig.clientWidth;
		var totWidth = this._labelWrap.clientWidth;
		var label = this._label;
		label.style.width = totWidth - hovTriggerWidth - 1 + 'px';
	},
	componentDidMount: function () {
		this.lang = {
			and: T('default.and').toLowerCase(),
			more: T('default.more2').toLowerCase()
		};
		this.setWidth();
	},
	componentDidUpdate: function () {
		this.setWidth();
	},
	render: function () {
		var self = this;
		var users = this.props.users;
		var meInArray = _.find(users, { id: this.props.selfId });
		var user = null;
		var label = '';
		var classNames = 'result-section section-25 user-section';
		var andMore = null;
		var tooltip = null;

		if (meInArray) {
			user = meInArray;
			label = user.name;
			classNames += ' blue';
		} else if (users.length) {
			user = users[0];
			label = user.name;
		}
		if (user) {
			if (users.length > 1) {
				andMore = (
					<span
						className="and-more"
						ref={function (ref) {
							self._hovTrig = ref;
						}}
					>
						{' ' + this.lang.and + ' ' + (users.length - 1) + ' ' + this.lang.more}
					</span>
				);

				tooltip = _.map(
					_.filter(users, function (u) {
						return u.id !== self.props.selfId;
					}),
					function (u) {
						return u.name;
					}
				).join('\n');
			}
		}

		var content = (
			<div>
				<ReactTemplates.TOOLS.avatar user={user} size={20} avatarService={Tools.avatarService} />
				<span
					ref={function (ref) {
						self._labelWrap = ref;
					}}
					className={user ? 'name-wrap' : 'no-user'}
				>
					<label className="uppercase">{this.props.title}</label>
					{user ? (
						<span>
							<span
								ref={function (ref) {
									self._label = ref;
								}}
								className="name-label"
							>
								{label}
							</span>
							{andMore}
						</span>
					) : (
						this.props.noResultLabel
					)}
				</span>
				<div className="clearfix" />
			</div>
		);

		return (
			<div className={classNames}>
				{andMore ? (
					<Tooltip title={tooltip} position="left">
						{content}
					</Tooltip>
				) : (
					content
				)}
			</div>
		);
	}
});

const searchRows = {};
var superSearchTimeout = null;
const Supersearch = ReactCreateClass({
	getInitialState: function () {
		return {
			open: false,
			openedViaShortcut: false,
			value: '',
			highlightedResult: 0,
			numResults: 0,
			loading: false,
			error: false,
			results: {},
			showMoreOf: null,
			limits: this.resetLimits(),
			prospectingResults: [],
			prospectingLoading: false,
			prospectingError: false
		};
	},
	setLanguage: function () {
		this.lang = {
			command: T('default.command'),
			placeholder: T('default.searchUpsales'),
			advancedTitle: T('filters.advancedSearch'),
			noResults: T('default.noResults'),
			typeToSearch: T('default.typeToSearch'),
			client: T('default.accounts'),
			subAccount: T('account.subaccounts'),
			contact: T('default.contacts'),
			activity: T('default.activities'),
			opportunity: T('default.opportunities'),
			order: T('default.orders'),
			name: T('default.name'),
			email: T('default.email'),
			appointment: T('default.appointments'),
			and: T('default.and').toLowerCase(),
			more: T('filters.more').toLowerCase(),
			accountHasActivity: T('search.accountHasActivity'),
			accountHasNoActivity: T('search.accountHasNoActivity'),
			showAll: T('default.showAll'),
			result: {
				subAccount: T('default.subaccountResult').toLowerCase(),
				client: T('default.accountResult').toLowerCase(),
				contact: T('default.contactResult').toLowerCase(),
				activity: T('default.activityResult').toLowerCase(),
				opportunity: T('default.opportunityResult').toLowerCase(),
				order: T('default.orderResult').toLowerCase(),
				appointment: T('default.appointmentResult').toLowerCase()
			},
			thatMatches: T('default.thatMatches').toLowerCase(),
			inactive: T('default.inactive').toLowerCase(),
			description: T('default.description'),
			get: T('soliditet.get'),
			results: T('default.results').toLowerCase(),
			resultSingular: {
				client: T('default.account').toLowerCase(),
				contact: T('default.contact').toLowerCase(),
				activity: T('default.activity').toLowerCase(),
				opportunity: T('default.opportunity').toLowerCase(),
				order: T('default.order').toLowerCase(),
				appointment: T('default.appointment').toLowerCase()
			},
			searchError: T('listError.default'),
			searchSmartInUpsales: T('navbar.quickSearch.searchSmartInUpsales'),
			phonenumberExplanation: T('navbar.quickSearch.phonenumberExplanation'),
			phone: T('tag.contact.phone'),
			shortcut: T('navbar.quickSearch.shortcut'),
			shortcutExplanation: T('navbar.quickSearch.shortcutExplanation'),
			quickNav: T('navbar.quickSearch.quickNav'),
			quickNavExplanation1: T('navbar.quickSearch.quickNavExplanation.1'),
			quickNavExplanation2: T('navbar.quickSearch.quickNavExplanation.2'),
			quickNavExplanation3: T('navbar.quickSearch.quickNavExplanation.3')
		};
	},
	componentDidMount: function () {
		this.setLanguage();

		var meta = Tools.AppService.getMetadata();
		this.currency = _.find(meta.customerCurrencies, { masterCurrency: true }).iso;

		this.self = Tools.AppService.getSelf();

		this.moreTypes = {
			client: this.lang.name.toLowerCase(),
			contact: this.lang.name.toLowerCase(),
			activity: this.lang.description.toLowerCase(),
			opportunity: this.lang.description.toLowerCase(),
			order: this.lang.description.toLowerCase(),
			appointment: this.lang.description.toLowerCase()
		};

		document.addEventListener('keydown', this.openOnShortCut);
		document.addEventListener('openSearch', this.open);
	},
	componentWillUnmount: function () {
		document.removeEventListener('keydown', this.openOnShortCut);
		document.removeEventListener('openSearch', this.open);
	},
	componentDidUpdate: function () {
		var self = this;
		var field = self.getField();
		if (self.state.open) {
			field.focus();

			var form = self.getForm();
			var containerHeight = window.innerHeight - 10;
			var resultWrap = this.getResults();

			if (form.scrollHeight > containerHeight && !form.classList.contains('large')) {
				form.classList.add('large');
			}
			resultWrap.style.maxHeight = window.innerHeight - 10 - 16 - 40 + 'px';
		} else {
			field.blur();
		}
	},
	openOnShortCut: function (e) {
		const isOpenCommand = Tools.browserService.isFirefox()
			? Tools.browserService.isOptionCombinedKey(e, 56, true) // Cannot override cmd+shift+7 in firefox
			: Tools.browserService.isOptionCombinedKey(e, 55, true);
		// Cmd/Ctrl+K (keyCode 75) without shift
		const isCmdK = e.keyCode === 75 && !e.shiftKey && (e.metaKey || e.ctrlKey);
		if (isCmdK) {
			e.preventDefault();
			if (this.state.open) {
				this.close();
			} else if (!document.body.classList.contains('modal-open')) {
				this.setState({ openedViaShortcut: true });
				this.open();
			}
			return;
		}
		if (isOpenCommand && !document.body.classList.contains('modal-open')) {
			this.setState({ openedViaShortcut: true });
			this.open();
		}
	},
	reFocus: function () {
		if (this.state.open) {
			this.getField().focus();
		}
	},
	getField: function () {
		return this._searchField;
	},
	getResults: function () {
		return this._resultsWrap;
	},
	getForm: function () {
		return this._form;
	},
	getCurtain: function () {
		return this._curtain;
	},
	getValue: function () {
		return this._searchField.value;
	},
	moveDown: function () {
		const rowSelector = '.SupersearchResultRow';
		const rowSelectedClass = 'SupersearchResultRow--selected';
		const resultWrap = jQuery(this.getResults());
		const selected = resultWrap.find(`${rowSelector}.${rowSelectedClass}`);
		const results = resultWrap.find(rowSelector);
		const index = jQuery(rowSelector).index(selected);

		// check if there is one more
		if (index !== results.length - 1) {
			selected.removeClass(rowSelectedClass);
			jQuery(results[index + 1]).addClass(rowSelectedClass);
		} else {
			selected.removeClass(rowSelectedClass);
			jQuery(results[0]).addClass(rowSelectedClass);
		}
	},
	moveUp: function () {
		const rowSelector = '.SupersearchResultRow';
		const rowSelectedClass = 'SupersearchResultRow--selected';
		const resultWrap = jQuery(this.getResults());
		const selected = resultWrap.find(`${rowSelector}.${rowSelectedClass}`);
		const results = resultWrap.find(rowSelector);
		const index = jQuery(rowSelector).index(selected);

		// check if there is one more
		if (index !== 0) {
			selected.removeClass(rowSelectedClass);
			jQuery(results[index - 1]).addClass(rowSelectedClass);
		} else {
			selected.removeClass(rowSelectedClass);
			jQuery(results[results.length - 1]).addClass(rowSelectedClass);
		}
	},
	goToAdvanced: function () {
		this.close();
		history.push('/advanced-search/accounts');
	},
	close: function () {
		if (!this.state.open) {
			return;
		}
		this.setState({ open: false, openedViaShortcut: false });
	},
	openCreateAccount: function () {
		const name = this.state.value?.trim() || '';
		this.close();
		const account = Tools.Account.new();
		account.name = name;
		Tools.$upModal.open('editAccount', {
			account: account,
			customerId: Tools.AppService.getCustomerId()
		});
	},
	open: function () {
		if (this.state.open) {
			return;
		}
		$(this.getField()).select();
		this.setState({ open: true });
	},
	resultClick: function (row, type) {
		this.close();
		this.setState({
			value: ''
		});

		var options = {};
		switch (type) {
			case 'client':
			case 'subAccount':
				return Tools.$state.go('account.dashboard', { id: row.id });
			case 'contact':
				return Tools.$state.go('contact.dashboard', { id: row.id });
			case 'activity':
				options.id = row.id;
				return Tools.$upModal.open('editActivity', options);
			case 'opportunity':
			case 'order':
				options.id = row.id;
				return openEditOrder(options);
			case 'appointment':
				options.id = row.id;
				return openEditAppointment(options);
		}
	},
	resetLimits: function () {
		return {
			client: 5,
			subAccount: 5,
			contact: 5,
			activity: 5,
			appointment: 5,
			order: 5,
			opportunity: 5
		};
	},
	showMore: function (type) {
		var self = this;

		if (superSearchTimeout) {
			clearTimeout(superSearchTimeout);
			superSearchTimeout = null;
		}

		superSearchTimeout = setTimeout(function () {
			var limits = self.state.limits;
			limits[type] += 5;

			var options = { type: type };
			options[type + 'Limit'] = limits[type];

			onSearch(self.state.value, self.searchTimestamp, options)
				.then(function (res) {
					self.state.results[type] = res.data[type];
					self.setState({
						results: self.state.results
					});
				})
				.catch(e => {
					logError(e, 'Failed searching');
				});

			self.setState({
				limits: limits
			});
		}, 200);
	},
	searchTimestamp: null,
	prospectingTimestamp: null,
	searchProspecting: function (searchValue) {
		var self = this;
		var hasProspecting =
			Tools.FeatureHelper.hasSoftDeployAccess('SUPERSEARCH_PROSPECTING') &&
			Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.PROSPECTING_BASIC);

		if (!hasProspecting) {
			return;
		}

		var ts = Date.now();
		self.prospectingTimestamp = ts;

		self.setState({
			prospectingLoading: true,
			prospectingError: false,
			prospectingResults: []
		});

		onProspectingSearch(searchValue)
			.then(function (res) {
				if (self.prospectingTimestamp !== ts) {
					return;
				}
				self.setState({
					prospectingLoading: false,
					prospectingResults: res.data || []
				});
			})
			.catch(function (e) {
				if (self.prospectingTimestamp !== ts) {
					return;
				}
				logError(e, 'Failed prospecting search in supersearch');
				self.setState({
					prospectingLoading: false,
					prospectingError: true
				});
			});
	},
	search: function () {
		this.searchTimestamp = Date.now();
		var self = this;
		self.setState({
			limits: this.resetLimits(),
			value: self.getValue() || '',
			loading: true,
			error: false,
			numResults: 0,
			results: {},
			highlightedResult: null,
			prospectingResults: [],
			prospectingLoading: false,
			prospectingError: false
		});

		if (superSearchTimeout) {
			clearTimeout(superSearchTimeout);
			superSearchTimeout = null;
		}

		superSearchTimeout = setTimeout(function () {
			var searchValue = self.state.value;
			onSearch(searchValue, self.searchTimestamp)
				.then(function (res) {
					if (!self.searchTimestamp || self.searchTimestamp === res.ts) {
						var selected = null;
						var selectedSort = 0;
						_.each(res.data, function (sectionRes, type) {
							if ((!selected || sectionRes.sortOrder < selectedSort) && sectionRes.data.length) {
								selected = type + '-' + sectionRes.data[0].id;
								selectedSort = sectionRes.sortOrder;
							}
						});

						self.setState({
							loading: false,
							results: res.data,
							numResults: res.numResults,
							highlightedResult: selected
						});

						// When CRM returns no results, automatically search external databases
						if (res.numResults === 0 && searchValue.length >= 2) {
							self.searchProspecting(searchValue);
						}
					} else {
						self.setState({ loading: false });
					}
				})
				.catch(function () {
					self.setState({
						loading: false,
						error: true
					});
				});
		}, 500);
	},
	keyDown: function (e) {
		// Prevent tab
		if (e.keyCode === 9) {
			e.preventDefault();
			e.stopPropagation();
			if (e.shiftKey) {
				this.moveUp();
			} else {
				this.moveDown();
			}
		}

		// escape
		if (e.keyCode === 27) {
			this.close();
		}

		// enter
		if (e.keyCode === 13) {
			e.preventDefault();
			e.stopPropagation();

			// Cmd/Ctrl+Enter opens Advanced search (command palette)
			if (
				this.state.openedViaShortcut &&
				(e.metaKey || e.ctrlKey) &&
				Tools.FeatureHelper.hasSoftDeployAccess('SUPER_COMMAND') &&
				Tools.AppService.getAccountSelf().features.advancedSearch
			) {
				this.goToAdvanced();
				return;
			}

			const rowSelector = '.SupersearchResultRow--selected';

			// open selected result
			var resultWrap = jQuery(this.getResults());
			resultWrap.find(rowSelector).click();
		}

		// up or down arrow
		if (
			e.keyCode === 38 ||
			(e.keyCode === 40 && (this.state.numResults || Tools.FeatureHelper.hasSoftDeployAccess('SUPER_COMMAND')))
		) {
			// preventDefault
			e.preventDefault();

			// up
			if (e.keyCode === 38) {
				this.moveUp();
			} else if (e.keyCode === 40) {
				// down
				this.moveDown();
			}
		}
	},
	escapeRegex: function (text) {
		return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	},
	isMatch: function (text) {
		if (text) {
			text = text.toString();
			var escapedText = this.escapeRegex(this.state.value.toString());
			var reg = new RegExp(escapedText, 'gi');
			var matches = text.match(reg);
			return !!matches && matches.length;
		} else {
			return false;
		}
	},
	diacritic: function (text) {
		return text
			.split('')
			.map(function (char) {
				if ('aâàá'.indexOf(char) > -1) {
					return '[aâàá]';
				}
				if ('eêëèé'.indexOf(char) > -1) {
					return '[eêëèé]';
				}
				if ('[iîïìí]'.indexOf(char) > -1) {
					return '[iîïìí]';
				}
				if ('[oôòó]'.indexOf(char) > -1) {
					return '[oôòó]';
				}
				if ('uûüùú'.indexOf(char) > -1) {
					return '[uûüùú]';
				}
				if ('[wŵẅẁẃ]'.indexOf(char) > -1) {
					return '[wŵẅẁẃ]';
				}
				if ('[yŷÿỳý]'.indexOf(char) > -1) {
					return '[yŷÿỳý]';
				}
				return char;
			})
			.join('');
	},
	highlight: function (text, field) {
		if (text) {
			text = text.toString();
			var escapedText = this.escapeRegex(this.state.value.toString().trim());
			var segments, matches, reg;

			var value = this.state.value;

			if (field === 'email' && value[0] !== '@') {
				escapedText = this.diacritic(escapedText);
				reg = new RegExp('(^|\\.|\\-|@)' + escapedText, 'gi');
				segments = text.split(reg);
				matches = text.match(reg);

				matches = matches.map(function (match) {
					if (
						(value[0] !== '.' && match[0] === '.') ||
						(value[0] !== '@' && match[0] === '@') ||
						(value[0] !== '-' && match[0] === '-')
					) {
						var splitString = match.split('');
						splitString.shift();
						return splitString.join('');
					}
					return match;
				});

				segments = segments.reduce(function (res, match, pos) {
					if (match === '@' || match === '-' || match === '.') {
						var index = res.length - 1;
						var last = res[index];
						if (last) {
							res[index] = res[index] + match;
						} else {
							res.push(match);
						}
					} else if (match === '' && res[res.length - 1] === '' && pos !== segments.length - 1) {
						// skipp
					} else {
						res.push(match);
					}

					return res;
				}, []);
			} else if ((field === 'phone' || field === 'cellPhone') && /[0-9 -+()]{5,}/.test(escapedText)) {
				var phoneRegexp =
					escapedText
						.split('')
						.filter(function (char) {
							return char >= '0' && char <= '9';
						})
						.map(function (char) {
							return '.*' + char;
						})
						.join('') + '.*';

				reg = new RegExp(phoneRegexp, 'gi');

				segments = text.split(reg);
				matches = text.match(reg);
			} else if (field === 'name') {
				escapedText = this.diacritic(escapedText);

				reg = new RegExp('\\b' + escapedText, 'gi');
				segments = text.split(reg);
				matches = text.match(reg);
			} else {
				reg = new RegExp(escapedText, 'gi');
				segments = text.split(reg);
				matches = text.match(reg);
			}

			var res = [];
			segments.forEach(function (segment, i) {
				res.push(<span key={'nomatch-' + i}>{segment}</span>);
				if (segments.length === i + 1) {
					return;
				}
				res.push(
					<span key={'match-' + i} className="ui-match">
						{matches[i]}
					</span>
				);
			});

			return res;
		} else {
			return text;
		}
	},

	onHover: function (e) {
		var sel = this.getResults().querySelector('.search-result.selected');
		if (sel) {
			sel.classList.remove('selected');
		}
		e.currentTarget.classList.add('selected');
	},

	render: function () {
		this.setLanguage();
		var self = this;
		var features = Tools.AppService.getAccountSelf().features;
		var results = this.state.results;
		var minCharForSearch = 2;
		var noResults =
			!this.state.loading && this.state.numResults === 0 && this.state.value.length >= minCharForSearch;
		var showSpinner = this.state.loading && this.state.value.length >= minCharForSearch;

		var headerIcons = {
			client: 'home',
			subAccount: 'subaccounts',
			contact: 'user',
			activity: 'activity',
			appointment: 'calendar',
			opportunity: 'pipeline',
			order: 'dollar'
		};

		var formClass = 'search-form';

		if (this.state.open) {
			formClass += ' focused';
		}
		if (this.props.size === 'md') {
			formClass += ' md';
		}

		var resRows = [];
		if (
			this.state.value.length >= minCharForSearch &&
			this.state.numResults !== 0 &&
			!this.state.loading &&
			!this.state.error
		) {
			var res = Object.values(results).sort((a, b) => a.sortOrder - b.sortOrder);
			res?.forEach(sectionRes => {
				var type = sectionRes.type;

				var numberOfLoadingRows = 0;
				if (self.state.limits[type] - sectionRes.metadata.limit !== 0) {
					numberOfLoadingRows = Math.min(
						self.state.results[type].metadata.total - sectionRes.metadata.limit,
						5
					);
				}

				if (sectionRes.metadata.total) {
					var section = [
						<SupersearchResultHeader
							key={'header-' + type}
							title={`${sectionRes.metadata.total} ${self.lang[type].toLowerCase()}`}
							icon={headerIcons[type]}
						/>,
						sectionRes.data.map((row, i) => {
							if (rowComponents[type]) {
								const NewComponent = rowComponents[type].component;
								const selected = type + '-' + row.id === this.state.highlightedResult;
								return (
									<NewComponent
										key={'results-' + type + '-' + i}
										item={row}
										onClick={() => this.resultClick(row, type)}
										searchStr={this.state.value}
										customFields={this.props.searchableFields[rowComponents[type].fieldKey]}
										closeSearch={this.close}
										defaultCurrency={this.currency}
										selected={selected}
									/>
								);
							}
							const Component = searchRows[type];
							return (
								<Component
									obj={row}
									resultClick={self.resultClick}
									highlight={self.highlight}
									isMatch={self.isMatch}
									lang={self.lang}
									key={'results-' + type + '-' + i}
									customFields={sectionRes.customFields}
									selected={type + '-' + row.id === self.state.highlightedResult}
									currency={self.currency}
									selfId={self.self.id}
									searchableFields={self.props.searchableFields}
									close={self.close}
									onHover={self.onHover}
								/>
							);
						})
					];
					if (numberOfLoadingRows > 0) {
						var height = 50 * numberOfLoadingRows + 'px';
						section.push(
							<div style={{ height: height }} className="loading" key="loading-more">
								<ReactTemplates.loader />
							</div>
						);
					} else if (sectionRes.metadata.total > results[type].data.length) {
						var numberOfRowsToFetch = Math.min(
							self.state.results[type].metadata.total - sectionRes.metadata.limit,
							5
						);
						section.push(
							<div
								className="search-result more-results"
								onClick={self.showMore.bind(self, type, null)}
								key={`show-more-${type}`}
							>
								{self.lang.get} {numberOfRowsToFetch} {self.lang.more}{' '}
								{numberOfRowsToFetch === 1 ? self.lang.resultSingular[type] : self.lang.result[type]}
							</div>
						);
					}

					resRows.push(section);
				}
			});
		}

		var advancedSearchToggle = null;
		if (features.advancedSearch) {
			advancedSearchToggle = (
				<button id="advanced-toggle" className="btn btn-link" type="button" onClick={this.goToAdvanced}>
					<Icon name="sliders" />
					<span>{self.lang.advancedTitle}</span>
				</button>
			);
		}

		const renderMediumSearchBar = this.props.size === 'md';
		return (
			<form
				autoComplete="off"
				className={formClass}
				role="search"
				ref={el => {
					this._form = el;
				}}
			>
				<div
					id="search-curtain"
					ref={el => {
						this._curtain = el;
					}}
					className={this.state.open ? 'visible' : ''}
					onClick={this.close}
				/>
				<ul className="nav-menu small-search">
					<li className="menu-item">
						<a id="search-toggle" onClick={this.open}>
							<b className="icon fa fa-search" />
						</a>
					</li>
				</ul>
				<div className={`navbar-search ${renderMediumSearchBar ? 'medium-search' : 'large-search'}`}>
					<b className="fa fa-search" />
					<input
						autoComplete="upsales-quicksearch"
						type="text"
						className="nav-search-input"
						ref={el => {
							this._searchField = el;
						}}
						max="30"
						placeholder={self.lang.placeholder}
						value={this.state.value}
						onChange={this.search}
						onFocus={this.open}
						onKeyDown={this.keyDown}
						data-test-id="quicksearch-input"
					/>
					{advancedSearchToggle}
				</div>
				<div
					id="search-results"
					ref={el => {
						this._resultsWrap = el;
					}}
				>
					{this.state.openedViaShortcut && Tools.FeatureHelper.hasSoftDeployAccess('SUPER_COMMAND') ? (
						<SupersearchActions
							query={this.state.value}
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
						/>
					) : null}
					{noResults && !this.state.error ? (
						<SupersearchNoResults
							query={this.state.value}
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
							onAddCompany={this.openCreateAccount}
							prospecting={
								Tools.FeatureHelper.hasSoftDeployAccess('SUPERSEARCH_PROSPECTING') &&
								Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.PROSPECTING_BASIC)
									? {
											results: this.state.prospectingResults,
											loading: this.state.prospectingLoading,
											error: this.state.prospectingError,
											onCompanyAdded: () => {
												this.close();
												this.setState({ value: '' });
											}
									  }
									: undefined
							}
						/>
					) : null}

					{this.state.error && (
						<span className="search-error">
							<b className="fa fa-warning" /> {self.lang.searchError}
						</span>
					)}

					{showSpinner ? (
						<div className="loading">
							<ReactTemplates.loader />
						</div>
					) : null}

					{resRows}
					{!showSpinner &&
					!resRows.length &&
					!noResults &&
					!this.state.error &&
					!(this.state.openedViaShortcut && Tools.FeatureHelper.hasSoftDeployAccess('SUPER_COMMAND')) ? (
						<SupersearchHistory
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
						/>
					) : null}

					{!this.state.error && !noResults && resRows.length > 0 && (
						<SupersearchAIActions
							query={this.state.value}
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
						/>
					)}

					{this.state.openedViaShortcut && Tools.FeatureHelper.hasSoftDeployAccess('SUPER_COMMAND') ? (
						<SupersearchFooter
							metaKey={Tools.browserService.isOSX() ? '⌘' : 'Ctrl'}
							showAdvanced={!!features.advancedSearch}
							onAdvanced={this.goToAdvanced}
						/>
					) : null}
				</div>
			</form>
		);
	}
});

searchRows.client = ReactCreateClass({
	componentDidMount: function () {
		this.lang = {
			user: T('default.user'),
			noUser: T('default.noUser')
		};
	},
	resultClick: function (item, type) {
		this.props.resultClick(item, type);
	},
	parseAddress: function (o) {
		if (o) {
			return (
				<span className="address-holder">
					{o.country ? <b className={'flag-icon flag-icon-' + o.country.toLowerCase()} /> : null}
					{o.city}
				</span>
			);
		}
	},
	getPhoneNr: function (key, icon) {
		var hl = this.props.highlight;
		var client = this.props.obj;
		var tel = ReactTemplates.TOOLS.upVoice(client, 'client', client[key]);
		return tel ? (
			<a target={tel.target} href={tel.href} onClick={tel.onClick}>
				{icon}
				{hl(client[key], key)}
			</a>
		) : null;
	},
	render: function () {
		var client = this.props.obj;
		var hl = this.props.highlight;
		var className = 'search-result' + (this.props.selected ? ' selected' : '');
		var rawAddress = _.find(client.addresses, { type: 'Visit' });
		var parsedAddress = this.parseAddress(rawAddress);
		var hasMarket = Tools.FeatureHelper.isAvailableProduct('MA');
		const hasInactiveAccounts = Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.INACTIVE_COMPANIES);

		if (hasInactiveAccounts && !client.active) {
			className += ' inactive-result';
		}

		return (
			<div
				className={className}
				onClick={this.resultClick.bind(this, client, 'client')}
				onMouseOver={this.props.onHover}
			>
				<div className="result-section section-35">
					<h4 style={{ marginBottom: '3px' }}>{hl(client.name, 'name')}</h4>
					<span style={{ marginRight: '5px', display: 'inline-block' }}>
						<ReactTemplates.TOOLS.leadStatus
							activity={client.hasActivity}
							activityOld={client.hadActivity}
							appointment={client.hasAppointment}
							appointmentOld={client.hadAppointment}
							opportunity={client.hasOpportunity}
							opportunityOld={client.hadOpportunity}
							order={client.hasOrder}
							orderOld={client.hadOrder}
						/>
					</span>
					{hasMarket ? (
						<span style={{ display: 'inline-block' }}>
							<ReactTemplates.TOOLS.eventTypes account={client} theKey={client.id} />
						</span>
					) : null}
				</div>
				<div className="result-section section-40">
					<div>{parsedAddress}</div>
					<div>
						<span>
							{client.phone ? (
								<span>{this.getPhoneNr('phone', <b className="fa fa-phone fa-fw" />)}</span>
							) : (
								''
							)}
						</span>
					</div>
				</div>
				{hasInactiveAccounts && !client.active ? (
					<div className="result-section section-25">
						<InactiveLabel />
					</div>
				) : (
					<NavbarUserComponent
						users={client.users ? client.users : []}
						noResultLabel={this.lang.noUser}
						title={this.lang.user}
						selfId={this.props.selfId}
					/>
				)}

				<NavbarCfResults
					customFields={this.props.searchableFields.account}
					values={client.custom}
					isMatch={this.props.isMatch}
					hl={hl}
					alwaysShow={true}
				/>
			</div>
		);
	}
});

searchRows.contact = ReactCreateClass({
	componentDidMount: function () {
		this.lang = {
			user: T('default.user'),
			noUser: T('default.noUser'),
			noAccount: T('default.noAccount'),
			inactive: T('default.inactive')
		};
	},
	resultClick: function (item, type) {
		this.props.resultClick(item, type);
	},
	sendEmail: function (e) {
		ReactTemplates.TOOLS.stopProp(e);
		this.props.close();
		openNewMailWithContact(this.props.obj);
	},
	getPhoneNr: function (key, icon) {
		var hl = this.props.highlight;
		var contact = this.props.obj;
		var tel = ReactTemplates.TOOLS.upVoice(contact, 'contact', contact[key]);
		return tel ? (
			<a target={tel.target} href={tel.href} onClick={tel.onClick}>
				{icon}
				{hl(contact[key], key)}
			</a>
		) : null;
	},
	render: function () {
		var contact = this.props.obj;
		var hl = this.props.highlight;
		var className = 'search-result' + (this.props.selected ? ' selected' : '');
		var hasMarket = Tools.FeatureHelper.isAvailableProduct('MA');

		if (!contact.active) {
			className += ' inactive-result';
		}

		var eventTypeProps = {
			account: contact,
			theKey: contact.id
		};

		return (
			<div
				className={className}
				onClick={this.resultClick.bind(this, contact, 'contact')}
				onMouseOver={this.props.onHover}
			>
				<div className="result-section section-35">
					<h4>
						<span className="contact-name">{hl(contact.name, 'name')}</span>
						{hasMarket ? <ReactTemplates.TOOLS.eventTypes {...eventTypeProps} /> : null}
						<span className="contact-score">{contact.score + 'p'}</span>
					</h4>
					<span className="result-subtitle uppercase">
						{contact.client ? contact.client.name : this.lang.noAccount}
					</span>
				</div>
				{contact.active ? (
					<div className="result-section section-20">
						<span>
							{contact.phone ? (
								<span>{this.getPhoneNr('phone', <b className="fa fa-phone fa-fw" />)}</span>
							) : (
								''
							)}
						</span>
						<span>
							{contact.cellPhone ? (
								<span>{this.getPhoneNr('cellPhone', <b className="fa fa-mobile fa-fw" />)}</span>
							) : (
								''
							)}
						</span>
					</div>
				) : null}
				{contact.active ? (
					<div className="result-section section-20">
						<span className="single-row">
							{contact.email ? (
								<a onClick={this.sendEmail}>
									<b className="fa fa-envelope" /> {hl(contact.email, 'email')}
								</a>
							) : (
								''
							)}
						</span>
					</div>
				) : null}
				{contact.active ? (
					<NavbarUserComponent
						users={contact.client && contact.client.users ? contact.client.users : []}
						noResultLabel={this.lang.noUser}
						title={this.lang.user}
						selfId={this.props.selfId}
					/>
				) : (
					<div className="result-section section-65">
						<InactiveLabel />
					</div>
				)}

				<NavbarCfResults
					customFields={this.props.searchableFields.contact}
					values={contact.custom}
					isMatch={this.props.isMatch}
					hl={hl}
				/>
			</div>
		);
	}
});

searchRows.activity = ReactCreateClass({
	componentDidMount: function () {
		this.lang = {
			user: T('default.user'),
			noUser: T('default.noUser'),
			noAccount: T('default.noAccount'),
			at: T('default.at').toLowerCase(),
			ended: T('default.ended'),
			for: T('default.for')
		};

		this.customerId = Tools.AppService.getCustomerId();
	},
	resultClick: function (item, type) {
		this.props.resultClick(item, type);
	},
	getDate: function (momentDate) {
		var str = '';
		if (momentDate.isValid()) {
			// If date is in future we display date calendar
			var today = new Date();
			if (
				momentDate.isSame(today, 'day') ||
				momentDate.isAfter(today) /* || (momentDate.isBefore(today) && momentDate.diff(today, 'months') >= 0)*/
			) {
				var d = momentDate.calendar();

				// the d is '0' if date is not today, tomorrow or yesterady (configured in momentLanguageConfig in app.js)
				str = <span>{d !== '0' ? <b>{d}</b> : momentDate.format('L')}</span>; // {' '}{momentDate.format('HH:mm')}
			} else {
				// check for IE since moment obj becomes weird in IE..
				str = Tools.browserService.isIE()
					? moment(momentDate.format('YYYY-MM-DD')).fromNow()
					: momentDate.fromNow(); // else we display ex. "4 years ago"
				str = this.lang.ended + ' ' + this.lang.for.toLowerCase() + ' ' + str;
			}
		}

		return <span>{str}</span>;
	},
	render: function () {
		var activity = this.props.obj;
		var hl = this.props.highlight;
		var className = 'search-result' + (this.props.selected ? ' selected' : '');
		var dateStr = this.getDate(moment(activity.date));

		if (activity.closeDate) {
			className += ' inactive-result';
		}

		return (
			<div
				className={className}
				onClick={this.resultClick.bind(this, activity, 'activity')}
				onMouseOver={this.props.onHover}
			>
				<div className="result-section section-35">
					<h4 style={{ marginBottom: '3px' }}>{hl(activity.description)}</h4>
					<span className="result-subtitle">
						<b className="fa fa-calendar-o" /> {dateStr}
					</span>
				</div>
				<div className="result-section section-40">
					<span>
						{activity.contacts && activity.contacts.length ? (
							<span>
								<ReactTemplates.TOOLS.contactHref
									onClick={this.props.close}
									customerId={this.customerId}
									id={activity.contacts[0].id}
									text={activity.contacts[0].name}
								/>{' '}
								{this.lang.at}
							</span>
						) : (
							this.lang.noContacts
						)}
					</span>
					<span className="result-subtitle">
						{activity.client ? activity.client.name : this.lang.noAccount}
					</span>
				</div>
				<NavbarUserComponent
					users={activity.users ? activity.users : []}
					noResultLabel={this.lang.noUser}
					title={this.lang.user}
					selfId={this.props.selfId}
				/>

				<NavbarCfResults
					customFields={this.props.searchableFields.activity}
					values={activity.custom}
					isMatch={this.props.isMatch}
					hl={hl}
				/>
			</div>
		);
	}
});

searchRows.opportunity = ReactCreateClass({
	componentDidMount: function () {
		this.lang = {
			user: T('default.user'),
			noUser: T('default.noUser'),
			noAccount: T('default.noAccount')
		};
	},
	resultClick: function (item, type) {
		this.props.resultClick(item, type);
	},
	render: function () {
		var opportunity = this.props.obj;
		var hl = this.props.highlight;
		var className = 'search-result' + (this.props.selected ? ' selected' : '');

		if (opportunity.probability === 0) {
			className += ' inactive-result';
		}

		return (
			<div
				className={className}
				onClick={this.resultClick.bind(this, opportunity, 'opportunity')}
				onMouseOver={this.props.onHover}
			>
				<div className="result-section section-35">
					<h4>{hl(opportunity.description)}</h4>
					<span className="result-subtitle uppercase">
						{opportunity.client ? opportunity.client.name : this.lang.noAccount}
					</span>
				</div>
				<div className="result-section section-20">
					<span className="single-row">
						{Tools.$filter('currencyFormat')(
							Math.round(opportunity.orderValue * 100) / 100,
							opportunity.currency ? opportunity.currency : this.props.currency
						)}
					</span>
				</div>
				<div className="result-section section-20">
					<span>{opportunity.stage ? opportunity.stage.name : ''}</span>
					<span className="result-subtitle">{opportunity.stage ? opportunity.probability + '%' : ''}</span>
				</div>
				<NavbarUserComponent
					users={opportunity.user ? [opportunity.user] : []}
					noResultLabel={this.lang.noUser}
					title={this.lang.user}
					selfId={this.props.selfId}
				/>

				<NavbarCfResults
					customFields={this.props.searchableFields.opportunity}
					values={opportunity.custom}
					isMatch={this.props.isMatch}
					hl={hl}
				/>
			</div>
		);
	}
});

searchRows.order = ReactCreateClass({
	componentDidMount: function () {
		this.lang = {
			user: T('default.user'),
			noUser: T('default.noUser'),
			noAccount: T('default.noAccount')
		};
	},
	resultClick: function (item, type) {
		this.props.resultClick(item, type);
	},
	render: function () {
		var order = this.props.obj;
		var hl = this.props.highlight;
		var className = 'search-result' + (this.props.selected ? ' selected' : '');

		return (
			<div
				className={className}
				onClick={this.resultClick.bind(this, order, 'order')}
				onMouseOver={this.props.onHover}
			>
				<div className="result-section section-35">
					<h4>{hl(order.description)}</h4>
					<span className="result-subtitle uppercase">
						{order.client ? order.client.name : this.lang.noAccount}
					</span>
				</div>
				<div className="result-section section-40">
					<span>
						{Tools.$filter('currencyFormat')(
							Math.round(order.orderValue * 100) / 100,
							order.currency ? order.currency : this.props.currency
						)}
					</span>
					<span className="result-subtitle">{moment(order.date).format('L')}</span>
				</div>
				<NavbarUserComponent
					users={order.user ? [order.user] : []}
					noResultLabel={this.lang.noUser}
					title={this.lang.user}
					selfId={this.props.selfId}
				/>

				<NavbarCfResults
					customFields={this.props.searchableFields.order}
					values={order.custom}
					isMatch={this.props.isMatch}
					hl={hl}
				/>
			</div>
		);
	}
});

searchRows.appointment = ReactCreateClass({
	componentDidMount: function () {
		this.lang = {
			user: T('default.user'),
			noUser: T('default.noUser'),
			noAccount: T('default.noAccount'),
			noContacts: T('default.noContacts'),
			more: T('default.more2').toLowerCase()
		};

		this.customerId = Tools.AppService.getCustomerId();
	},
	resultClick: function (item, type) {
		this.props.resultClick(item, type);
	},
	getDate: function (momentDate) {
		var str = '';
		if (momentDate.isValid()) {
			// If date is in future we display date calendar
			var today = new Date();
			if (
				momentDate.isSame(today, 'day') ||
				momentDate.isAfter(today) /* || (momentDate.isBefore(today) && momentDate.diff(today, 'months') >= 0)*/
			) {
				var d = momentDate.calendar();

				// the d is '0' if date is not today, tomorrow or yesterady (configured in momentLanguageConfig in app.js)
				str = <span>{d !== '0' ? <b>{d}</b> : momentDate.format('L LT')}</span>;
			} else {
				// check for IE since moment obj becomes weird in IE..
				str = Tools.browserService.isIE()
					? moment(momentDate.format('YYYY-MM-DD')).fromNow()
					: momentDate.fromNow(); // else we display ex. "4 years ago"
			}
		}

		return <span>{str}</span>;
	},
	render: function () {
		var appointment = this.props.obj;
		var hl = this.props.highlight;
		var className = 'search-result' + (this.props.selected ? ' selected' : '');
		var contactText = '';
		var appointmentDate = moment(appointment.date);
		var dateStr = this.getDate(appointmentDate);
		if (appointment.contacts.length > 1) {
			contactText = ' +' + (appointment.contacts.length - 1) + ' ' + this.lang.more;
		}

		if (moment().isAfter(appointmentDate)) {
			className += ' inactive-result';
		}

		return (
			<div
				className={className}
				onClick={this.resultClick.bind(this, appointment, 'appointment')}
				onMouseOver={this.props.onHover}
			>
				<div className="result-section section-35">
					<h4>{hl(appointment.description)}</h4>
					<span className="result-subtitle">
						{dateStr}
						{appointment.location ? ' - ' + appointment.location : null}
					</span>
				</div>
				<div className="result-section section-40">
					<span>
						{appointment.contacts.length ? (
							<span>
								<ReactTemplates.TOOLS.contactHref
									onClick={this.props.close}
									customerId={this.customerId}
									id={appointment.contacts[0].id}
									text={appointment.contacts[0].name}
								/>{' '}
								{contactText}
							</span>
						) : (
							this.lang.noContacts
						)}
					</span>
					<span className="result-subtitle uppercase">
						{appointment.client ? appointment.client.name : this.lang.noAccount}
					</span>
				</div>
				<NavbarUserComponent
					users={appointment.users || []}
					noResultLabel={this.lang.noUser}
					title={this.lang.user}
					selfId={this.props.selfId}
				/>

				<NavbarCfResults
					customFields={this.props.searchableFields.appointment}
					values={appointment.custom}
					isMatch={this.props.isMatch}
					hl={hl}
				/>
			</div>
		);
	}
});

export default Supersearch;
